export const getQuantityHourByService = async (hourMin: any) => {
    return Math.ceil(hourMin / 60);
}
